'use client';

import { useEffect, useState } from 'react';
import { Icon } from './Icon';

export function getSecondsUntil(targetIso: string | null): number {
  if (!targetIso) return 0;
  const now = new Date();
  const target = new Date(targetIso);
  return Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
}

type Props = {
  targetIso: string | null;
};

export const Stopwatch = ({ targetIso }: Props) => {
  const [timeLeft, setTimeLeft] = useState<number>(() =>
    targetIso ? getSecondsUntil(targetIso) : 0
  );

  const formatTime = (seconds: number) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  useEffect(() => {
    if (!targetIso) {
      setTimeLeft(0);
      return;
    }

    setTimeLeft(getSecondsUntil(targetIso));

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) return 0;
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [targetIso]);

  return (
    <div className="flex items-center gap-1">
      <Icon name="stopwatch" className="size-4" />
      <span className="text-xs font-medium">{formatTime(timeLeft ?? 0)}</span>
    </div>
  );
};
